import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';

export const LFPlay = ({ size = 14, title = 'Play', fill = colors.kermit }: SVGDefaultProps) => {
  const height = Number(size) * 2.85;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 15 16">
      {Boolean(title) && <title>{title}</title>}
      <g fill={fill}>
        <path d="M5.69 10.63l5-3.1a.19.19 0 00.06-.25l-.06-.06-5-3.1a.18.18 0 00-.25 0 .36.36 0 000 .1v6.21a.17.17 0 00.17.18z" />
        <path d="M12.58 2.16A7.28 7.28 0 007.37 0a7.37 7.37 0 100 14.74 7.39 7.39 0 007.37-7.37 7.31 7.31 0 00-2.16-5.21zm.72 5.22a5.92 5.92 0 11-5.92-5.92 5.93 5.93 0 015.92 5.92z" />
      </g>
    </svg>
  );
};
